/* eslint-disable array-callback-return */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import Grid from '../../../../../SharedModules/Table/TableGridWithFeatures';
import tableHead from './gridComponents/tableHead';
import {
  getHolidaysDetails,
  dispatchSetHolidaysDetails,
  dispatchErrorMessages,
  updateHolidayDetails,
} from '../../store/actions';
import {
  navigateToNextCell,
  onCellFocused,
  tabToNextCell,
} from '../../../../../SharedModules/AgGridUtilities/suppressNavigation';
import SaveCancelPopup from '../../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import DeleteActionRender from '../deleteActionRender';
import TextBoxRender from '../textBoxRender';
import DatePickerRender from './gridComponents/DatePickerRender';
import Spinner from '../../../../../SharedModules/Spinner/SpinnerNew';

function Holiday(props) {
  const {
    setUpdateHoliday,
    fullScreenView,
    setFullScreenView,
    setSuccessMessage,
    setDisabledSaveCancelBtn,
    disabledSaveCancelBtn,
    isReadOnly,
    isEnabledByRole,
    spinnerLoader,
  } = props;
  const dispatch = useDispatch();

  const searchHolidayDetail = (value) => dispatch(getHolidaysDetails(value));

  const holidayData = useSelector(
    (state) => state?.sharedState?.SystemProviderReducer?.holiday
  );
  const gridRef = React.useRef();
  const childRef = React.useRef(null);
  const [gridApi, setGridApi] = React.useState(gridRef);
  const [columnApi, setColumnApi] = React.useState(null);
  const [latestDate, setLatestDate] = React.useState(null);
  const [deletePopup, setDeletePopup] = useState(false);
  const [deleteData, setDeleteData] = useState();
  const errorMessages = useSelector(
    (state) => state?.sharedState?.SystemProviderReducer?.errorMessages
  );

  const onGridReady = useCallback((params) => {
    setGridApi(params.api);
    setColumnApi(params.columnApi);
  }, []);

  const setErrorMessages = (messages) => {
    dispatch(dispatchErrorMessages(messages));
  };
  const setHolidayData = (data) => {
    dispatch(dispatchSetHolidaysDetails(data));
  };

  useEffect(() => {
    const fetchData = async () => {
      if (!holidayData || holidayData.length === 0) {
        try {
          await searchHolidayDetail();
        } catch (error) {
        } finally {
          setFullScreenView(false);
        }
      }
    };
    fetchData();
  }, []);

  // if necessary can be used in future.
  // useEffect(() => {
  //   if (!holidayData || holidayData.length === 0) {
  //     searchHolidayDetail();
  //   }
  //   setFullScreenView(false);
  // }, []);

  useEffect(() => {
    // if (disabledSaveCancelBtn) {
    //   setTimeout(() => searchHolidayDetail(), 1000);
    // }
    const fetchData = async () => {
      if (disabledSaveCancelBtn) {
        await searchHolidayDetail();
      }
    };
    fetchData();
  }, [disabledSaveCancelBtn]);

  const [editedRowData, setEditedRowData] = useState(null);

  const markRowAsEdited = (rowData) => {
    setEditedRowData(rowData);
  };

  useEffect(() => {
    if (holidayData) {
      setUpdateHoliday(holidayData);
    }
  }, [holidayData]);

  useEffect(() => {
    if (disabledSaveCancelBtn) {
      setLatestDate(null);
    }
  }, [disabledSaveCancelBtn]);

  useEffect(() => {
    if (editedRowData) {
      const transformedData = {
        updateRecord: true,
        deleteFlag: false,
        holidayDescr: editedRowData.holidayDescr,
        holidayDt: editedRowData.holidayDt,
      };

      // Perform your API call using setUpdateHoliday to update the edited row
      setUpdateHoliday(transformedData);
    }
  }, [editedRowData]);

  const frameworkComponents = {
    TextBoxRender: (cellInfo) => (
      <TextBoxRender
        cellInfo={cellInfo}
        disabled={isReadOnly || !isEnabledByRole}
        setDisabledSaveCancelBtn={setDisabledSaveCancelBtn}
        addAction={addRow}
      />
    ),
    holidayDtDatePicker: (cellInfo) => (
      <DatePickerRender
        setDisabledSaveCancelBtn={setDisabledSaveCancelBtn}
        isEnabledByRole={isEnabledByRole}
        {...cellInfo}
      />
    ),
    DeleteBoxRender: (cellInfo) => (
      <DeleteActionRender
        cellInfo={cellInfo}
        setDeletePopup={setDeletePopup}
        setDeleteData={setDeleteData}
        disabled={isReadOnly || !isEnabledByRole}
      />
    ),
  };

  const addRow = (e, data, colApi) => {
    setDisabledSaveCancelBtn(false);
    setSuccessMessage([]);
    const dataWithNewRows = data
      ? [...data]
      : holidayData
      ? [...holidayData]
      : [];
    const newRows = [];

    // Increment the last added date by 7 days
    let newDate = latestDate ? moment(latestDate).add(7, 'days') : moment();

    // const formatForCompare = (m) => m.clone().startOf('day').format('MM/DD/YYYY');
    // const existingDates = new Set(
    //   (dataWithNewRows || [])
    //     .filter((d) => !d.deleteFlag && d.holidayDt)
    //     .map((d) => moment(d.holidayDt).format('MM/DD/YYYY'))
    // );
    // let attempts = 0;
    //  while (existingDates.has(formatForCompare(newDate)) && attempts < 52) {
    //   newDate = newDate.add(7, 'days');
    //   attempts += 1;
    // }

    const newRow = {
      id: uuidv4(),
      holidayDt: newDate.clone().startOf('day').toISOString(),
      holidayDescr: '',
      lastUpdateDt: moment().startOf('day').toISOString(),
      deleteFlag: false,
      newRow: true,
    };

    newRows.push(newRow);
    dataWithNewRows.unshift(newRow);
    setHolidayData(dataWithNewRows);

    // Update the latest date
    setLatestDate(newDate.toDate());

    // Apply sorting on the date column
    if (columnApi) {
      columnApi.applyColumnState({
        state: [{ colId: 'holidayDescr', sort: 'asc' }],
        defaultState: { sort: null },
      });
    }
    if (colApi) {
      colApi.applyColumnState({
        state: [{ colId: 'holidayDescr', sort: 'asc' }],
        defaultState: { sort: null },
      });
    }

    setUpdateHoliday(newRows);
    setUpdateHoliday((prevUpdateHoliday) => {
      const updatedRows = Array.isArray(prevUpdateHoliday)
        ? prevUpdateHoliday
        : [];
      return [...updatedRows, ...newRows];
    });
  };

  const handleFullScreenViewClick = () => {
    setFullScreenView(!fullScreenView);
  };
  const onEditingStopped = (e) => {
    setSuccessMessage([]);
    setDisabledSaveCancelBtn(false);
  };
  const gridHeight = fullScreenView ? '60vh' : 360;

  const deleteFun = () => {
    setSuccessMessage([]);
    setDisabledSaveCancelBtn(false);

    // Get the id of the row to delete
    const idToDelete = deleteData?.node?.data.id;

    // Update the data, marking the row with the matching id as deleted
    const updatedData = holidayData.map((dataItem) => {
      if (dataItem.id === idToDelete) {
        return {
          ...dataItem,
          deleteFlag: true,
          //updateRecord: true,
        };
      }
      return dataItem;
    });

    // Apply the transaction to delete the row in the grid
    deleteData.api.applyTransaction({
      remove: [deleteData?.node?.data],
    });

    // Update state variables
    setHolidayData(updatedData);
  setLatestDate(null);
    setUpdateHoliday((prevUpdateHoliday) => {
      const deletedRow = holidayData.find(
        (dataItem) => dataItem.id === idToDelete
      );
      const updatedRows = Array.isArray(prevUpdateHoliday)
        ? prevUpdateHoliday
        : [];
      return [...updatedRows, deletedRow];
    });
  };

  return (
    <>
      <div>
        <SaveCancelPopup
          data-testid="handleDelete"
          open={deletePopup}
          title="Delete"
          moduleName="the selected Holiday"
          onConfim={() => {
            setDeletePopup(false);
            deleteFun();
          }}
          onCancel={() => {
            setDeletePopup(false);
          }}
        />
        <Spinner load={spinnerLoader} />
        <div className="panel-body FRR-custom-table tbl-manufacturer-inner frr-log_chk">
          <Grid
            onGridReady={onGridReady}
            ref={childRef}
            setGridApi={setGridApi}
            gridHeight={gridHeight}
            rowData={holidayData?.filter((x) => !x.deleteFlag)}
            columnDefs={tableHead}
            frameworkComponents={frameworkComponents}
            data-testid="onEditingStopped"
            enterMovesDown
            suppressCellFocus
            onCellFocused={onCellFocused}
            singleClickEdit={false}
            navigateToNextCell={navigateToNextCell}
            // tabToNextCell={tabToNextCell}
            onCellValueChanged={onEditingStopped}
            fullScreenView={fullScreenView}
            handleFullScreenViewClick={handleFullScreenViewClick}
            exportFile
            fileName="Holiday"
            addTxt="Add Holiday"
            addAction={addRow}
            disableAddAction={isReadOnly || !isEnabledByRole}
          />
        </div>
      </div>
    </>
  );
}
export default withRouter(Holiday);
